import { useEffect, useRef } from "react";
import * as THREE from "three";
import { cloneAndScaleUV } from "./geometryUltis";

export default function useWindowBoundingDataChecker({ nodes, window, onBoundingDataChanged, group }) {
  const lastBoundingDataRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
       if (window.type === 'pcv' || window.type === 'openings' || window.type === 'plexi' || window.type === 'openings_flaps') {
        if (group) {
          // Calculate bounding box from the group
          const box = new THREE.Box3().setFromObject(group.current);
          const size = new THREE.Vector3();
          const center = new THREE.Vector3();
          box.getSize(size);
          box.getCenter(center);

          const newBoundingData = { box, size, center };

          const boundingDataEquals = (a, b) => {
            if (!a || !b) return false;

            if (
              !(a.size instanceof THREE.Vector3) || !(b.size instanceof THREE.Vector3) ||
              !(a.center instanceof THREE.Vector3) || !(b.center instanceof THREE.Vector3)
            ) {
              return false;
            }

            return (
              a.size.distanceTo(b.size) < 1e-5 &&
              a.center.distanceTo(b.center) < 1e-5
            );
          };

          if (
            window.boundingData == null ||
            !boundingDataEquals(window.boundingData, newBoundingData) ||
            lastBoundingDataRef.current == null ||
            !boundingDataEquals(lastBoundingDataRef.current, newBoundingData)
          ) {
            onBoundingDataChanged(newBoundingData);
            lastBoundingDataRef.current = newBoundingData;
          }
        }
      }
    }, 100);

    return () => clearInterval(interval);
  }, [nodes, window.height, window.width, window.boundingData, onBoundingDataChanged]);
}
